import { jsx } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { styled, Radio as Radio$1 } from "@mui/material";
import { forwardRef } from "react";
import { Spacing } from "../../foundations/spacing.es.js";
const LargeRadio = styled(Radio$1)({
  "& .MuiSvgIcon-root": {
    fontSize: Spacing["1750"]
  }
});
const Radio = forwardRef(function Radio2({
  isLarge,
  ...rest
}, ref) {
  if (isLarge)
    return /* @__PURE__ */ jsx(LargeRadio, { ...rest });
  return /* @__PURE__ */ jsx(Radio$1, { ref, ...rest });
});
export {
  Radio
};
//# sourceMappingURL=radio.es.js.map
